export const ErrCode_DocNotFound = 'DocNotFound';
export const ErrCode_NotAllowed = 'NotAllowed';
export const ErrCode_Auth_UserNotFound = 'auth/user-not-found';
export const ErrCode_NoDataFound = 'NoDataFound';
export const ErrCode_AlreadyExists = 'AlreadyExists';
export const ErrCode_IncorrectDataFormat = 'IncorrectDataFormat';
